import React from 'react';
import styled from 'styled-components';
import PageContainer from '../../components/containers/PageContainer';
import { theme } from '../../assets/styles/theme';
import AdminChannelsTable from './adminChannels/table/AdminChannelsTable';

const Container = styled.div`
  padding: 10px ${theme.paddingStandard}px 0 ${theme.paddingStandard}px;
  flex-direction: column;
  display: flex;
  width: 100%;
`;

const AdminChannels = () => {
  return (
    <PageContainer>
      <Container>
        <AdminChannelsTable />
      </Container>
    </PageContainer>
  );
};

export default AdminChannels;
